/**
 * This function processes specific dropdown fields by extracting their `.value` property
 */
export function extractDropdowns(payload) {
  const dropdownFields = ['initialTrainingClassCountry', 'country', 'location', 'initialTrainingClassLocation']

  const dropdownValues = dropdownFields
    .map(mapDropdownField(payload))
    .reduce((acc, [field, value]) => {
    acc[field] = value

    return acc
  }, {})

  const sanitizedRoles = Array.isArray(payload.roles)
    ? payload.roles.map(role => (role && typeof role === 'object' ? role.value : role))
    : payload.roles

  return {...payload, ...dropdownValues, roles: sanitizedRoles };
}

/**
 * Validates that all mandatory fields are present in the payload.
 * @param {Object} payload - The payload to validate
 * @param {string[]} excludeFields - Fields to exclude from validation (e.g., ['username'] for updates)
 */
export function checkMandatoryFields(payload, excludeFields = []) {
  const mandatoryFields = ['email', 'username', 'enabled', 'firstName', 'lastName', 'cellPhone', 'country', 'availableForScheduling']
    .filter(field => !excludeFields.includes(field))

  const missingFields = mandatoryFields.filter(field =>
    payload[field] == null ||
    payload[field] === ''
  )

  // Special validation for roles (must be an array with at least one element)
  if (!payload.roles || !Array.isArray(payload.roles) || payload.roles.length === 0) {
    missingFields.push('roles')
  }

  if (missingFields.length === 0) return;

  return `The following fields must be completed: ${missingFields.join(', ')}`
}

/**
 * Removes empty string values from optional fields by converting them to null.
 * Also trims whitespace from valid string values.
 */
export function cleanEmptyFields(payload) {
  const optionalFields = [
    'zip', 'address', 'city', 'location', 'homePhone',
    'birthDay', 'birthMonth', 'initialTrainingClassNumber',
    'initialTrainingClassCity', 'initialTrainingClassLocation',
    'initialTrainingClassCountry', 'initialTrainingClassDate', 'notes'
  ]
  const cleanedPayload = { ...payload }

  for (const field of optionalFields) {
    const value = cleanedPayload[field]

    if (typeof value === 'string' && value.trim() === '') {
      cleanedPayload[field] = null
    }
    else if (typeof value === 'string') {
      cleanedPayload[field] = value.trim()
    }
  }

  return cleanedPayload
}

function mapDropdownField(payload) {
  return function(dropdownField) {
    const payloadField = payload[dropdownField]
    const sanitizedValue = payloadField ? payloadField.value : payloadField
  
    return [dropdownField, sanitizedValue];
  };
}